import sizings from 'widget_main/styles/sizings.scss';

const MOBILE_SCREEN_WIDTH = Number(sizings.mobileScreenWidth.slice(0, -2));
const MOBILE_SCREEN_HEIGHT = Number(sizings.mobileScreenHeight.slice(0, -2));

export const isMobileViewport = () => {
  const isMobile =
    window.parent.innerWidth <= MOBILE_SCREEN_WIDTH ||
    window.parent.innerHeight <= MOBILE_SCREEN_HEIGHT;

  return isMobile;
};
